import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import { makeStyles } from 'tss-react/mui';
import EmptyMediaIcon from '../../components/Icons/EmptyMediaIcon';
import useMediaStyles from '../../components/useMediaStyles';
import { MediaType } from './mimeType';

type MediaRendererProps = {
  src?: string | null;
  autoPlay?: boolean;
  type?: MediaType;
  aspectRatio?: string;
  className?: string;
  mediaContentContain?: boolean;
  showPlayButton?: boolean;
  isDisabled?: boolean;
  alt?: string;
  loading?: 'lazy' | 'eager';
  hideEmptyIcon?: boolean;
};

const useStyles = makeStyles()(() => ({
  playIcon: {
    position: 'absolute',
    zIndex: 999,
  },
}));

const MediaRenderer = ({
  src,
  type = 'IMAGE',
  autoPlay,
  className,
  aspectRatio,
  mediaContentContain,
  isDisabled = false,
  showPlayButton = true,
  alt = 'mídia',
  loading,
  hideEmptyIcon = false,
}: MediaRendererProps) => {
  const { classes: mediaClasses } = useMediaStyles({ imageAspectRatioPadding: aspectRatio });
  const { classes, cx } = useStyles();

  const mediaClass = mediaContentContain
    ? mediaClasses.mediaContentContain
    : mediaClasses.mediaContentCover;

  if (type !== 'VIDEO' || !src) {
    return (
      <div
        className={cx(mediaClasses.mediaBoxWithAspectRatio, className, {
          [mediaClasses.disabledMediaOverlay]: isDisabled,
        })}
      >
        {src && <img src={src} className={cx(mediaClass)} alt={alt} loading={loading} />}
        {!src && !hideEmptyIcon && <EmptyMediaIcon />}
      </div>
    );
  }
  return !autoPlay ? (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        flex: 1,
      }}
    >
      {showPlayButton && <PlayCircleFilledIcon className={classes.playIcon} fontSize="large" />}
      <div className={cx(mediaClasses.mediaBoxWithAspectRatio, className)}>
        <video
          src={src}
          className={mediaClass}
          autoPlay={autoPlay}
          loop
          muted
          disablePictureInPicture
          playsInline
        />
      </div>
    </div>
  ) : (
    <div className={cx(mediaClasses.mediaBoxWithAspectRatio, className)}>
      <video
        src={src}
        className={mediaClass}
        autoPlay={autoPlay}
        loop
        muted
        disablePictureInPicture
        playsInline
      />
    </div>
  );
};

export default MediaRenderer;
